
// Auto-generated DAO contract configuration
export const DAO_CONTRACTS = {
  "DAOToken": {
    "abi": [
      {
        "inputs": [
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "symbol",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "initialSupply",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "initialOwner",
            "type": "address"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "inputs": [],
        "name": "CheckpointUnorderedInsertion",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "ECDSAInvalidSignature",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "length",
            "type": "uint256"
          }
        ],
        "name": "ECDSAInvalidSignatureLength",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "s",
            "type": "bytes32"
          }
        ],
        "name": "ECDSAInvalidSignatureS",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "increasedSupply",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "cap",
            "type": "uint256"
          }
        ],
        "name": "ERC20ExceededSafeSupply",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "allowance",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "needed",
            "type": "uint256"
          }
        ],
        "name": "ERC20InsufficientAllowance",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "sender",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "balance",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "needed",
            "type": "uint256"
          }
        ],
        "name": "ERC20InsufficientBalance",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "approver",
            "type": "address"
          }
        ],
        "name": "ERC20InvalidApprover",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "receiver",
            "type": "address"
          }
        ],
        "name": "ERC20InvalidReceiver",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "sender",
            "type": "address"
          }
        ],
        "name": "ERC20InvalidSender",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          }
        ],
        "name": "ERC20InvalidSpender",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
          }
        ],
        "name": "ERC2612ExpiredSignature",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "signer",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "ERC2612InvalidSigner",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "timepoint",
            "type": "uint256"
          },
          {
            "internalType": "uint48",
            "name": "clock",
            "type": "uint48"
          }
        ],
        "name": "ERC5805FutureLookup",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "ERC6372InconsistentClock",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "currentNonce",
            "type": "uint256"
          }
        ],
        "name": "InvalidAccountNonce",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "InvalidShortString",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "OwnableInvalidOwner",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "OwnableUnauthorizedAccount",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint8",
            "name": "bits",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "SafeCastOverflowedUintDowncast",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "string",
            "name": "str",
            "type": "string"
          }
        ],
        "name": "StringTooLong",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "expiry",
            "type": "uint256"
          }
        ],
        "name": "VotesExpiredSignature",
        "type": "error"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "spender",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "Approval",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "delegator",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "fromDelegate",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "toDelegate",
            "type": "address"
          }
        ],
        "name": "DelegateChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "delegate",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "previousVotes",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newVotes",
            "type": "uint256"
          }
        ],
        "name": "DelegateVotesChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [],
        "name": "EIP712DomainChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "previousOwner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "Transfer",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "CLOCK_MODE",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "DOMAIN_SEPARATOR",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          }
        ],
        "name": "allowance",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "approve",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "balanceOf",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "uint32",
            "name": "pos",
            "type": "uint32"
          }
        ],
        "name": "checkpoints",
        "outputs": [
          {
            "components": [
              {
                "internalType": "uint48",
                "name": "_key",
                "type": "uint48"
              },
              {
                "internalType": "uint208",
                "name": "_value",
                "type": "uint208"
              }
            ],
            "internalType": "struct Checkpoints.Checkpoint208",
            "name": "",
            "type": "tuple"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "clock",
        "outputs": [
          {
            "internalType": "uint48",
            "name": "",
            "type": "uint48"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "decimals",
        "outputs": [
          {
            "internalType": "uint8",
            "name": "",
            "type": "uint8"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "delegatee",
            "type": "address"
          }
        ],
        "name": "delegate",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "delegatee",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "nonce",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "expiry",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "v",
            "type": "uint8"
          },
          {
            "internalType": "bytes32",
            "name": "r",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "s",
            "type": "bytes32"
          }
        ],
        "name": "delegateBySig",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "delegates",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "eip712Domain",
        "outputs": [
          {
            "internalType": "bytes1",
            "name": "fields",
            "type": "bytes1"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "version",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "chainId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "verifyingContract",
            "type": "address"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          },
          {
            "internalType": "uint256[]",
            "name": "extensions",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "timepoint",
            "type": "uint256"
          }
        ],
        "name": "getPastTotalSupply",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timepoint",
            "type": "uint256"
          }
        ],
        "name": "getPastVotes",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "getVotes",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "name",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "nonces",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "numCheckpoints",
        "outputs": [
          {
            "internalType": "uint32",
            "name": "",
            "type": "uint32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "owner",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "spender",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "deadline",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "v",
            "type": "uint8"
          },
          {
            "internalType": "bytes32",
            "name": "r",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "s",
            "type": "bytes32"
          }
        ],
        "name": "permit",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "symbol",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "totalSupply",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "transfer",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "from",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "transferFrom",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      }
    ],
    "bytecode": "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"
  },
  "DAOGovernor": {
    "abi": [
      {
        "inputs": [
          {
            "internalType": "contract IVotes",
            "name": "_token",
            "type": "address"
          },
          {
            "internalType": "contract TimelockController",
            "name": "_timelock",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "_votingDelay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_votingPeriod",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_proposalThreshold",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "_quorumPercentage",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "inputs": [],
        "name": "CheckpointUnorderedInsertion",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "FailedCall",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "voter",
            "type": "address"
          }
        ],
        "name": "GovernorAlreadyCastVote",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "GovernorAlreadyQueuedProposal",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "GovernorDisabledDeposit",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "proposer",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "votes",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "threshold",
            "type": "uint256"
          }
        ],
        "name": "GovernorInsufficientProposerVotes",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "targets",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "calldatas",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "values",
            "type": "uint256"
          }
        ],
        "name": "GovernorInvalidProposalLength",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "quorumNumerator",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "quorumDenominator",
            "type": "uint256"
          }
        ],
        "name": "GovernorInvalidQuorumFraction",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "voter",
            "type": "address"
          }
        ],
        "name": "GovernorInvalidSignature",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "GovernorInvalidVoteParams",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "GovernorInvalidVoteType",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "votingPeriod",
            "type": "uint256"
          }
        ],
        "name": "GovernorInvalidVotingPeriod",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "GovernorNonexistentProposal",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "GovernorNotQueuedProposal",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "GovernorOnlyExecutor",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "GovernorQueueNotImplemented",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "proposer",
            "type": "address"
          }
        ],
        "name": "GovernorRestrictedProposer",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "GovernorUnableToCancel",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "enum IGovernor.ProposalState",
            "name": "current",
            "type": "uint8"
          },
          {
            "internalType": "bytes32",
            "name": "expectedStates",
            "type": "bytes32"
          }
        ],
        "name": "GovernorUnexpectedProposalState",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "currentNonce",
            "type": "uint256"
          }
        ],
        "name": "InvalidAccountNonce",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "InvalidShortString",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint8",
            "name": "bits",
            "type": "uint8"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          }
        ],
        "name": "SafeCastOverflowedUintDowncast",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "string",
            "name": "str",
            "type": "string"
          }
        ],
        "name": "StringTooLong",
        "type": "error"
      },
      {
        "anonymous": false,
        "inputs": [],
        "name": "EIP712DomainChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "ProposalCanceled",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "proposer",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "indexed": false,
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "indexed": false,
            "internalType": "string[]",
            "name": "signatures",
            "type": "string[]"
          },
          {
            "indexed": false,
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "voteStart",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "voteEnd",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "string",
            "name": "description",
            "type": "string"
          }
        ],
        "name": "ProposalCreated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "ProposalExecuted",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "etaSeconds",
            "type": "uint256"
          }
        ],
        "name": "ProposalQueued",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "oldProposalThreshold",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newProposalThreshold",
            "type": "uint256"
          }
        ],
        "name": "ProposalThresholdSet",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "oldQuorumNumerator",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newQuorumNumerator",
            "type": "uint256"
          }
        ],
        "name": "QuorumNumeratorUpdated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "oldTimelock",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "newTimelock",
            "type": "address"
          }
        ],
        "name": "TimelockChange",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "voter",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "weight",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "string",
            "name": "reason",
            "type": "string"
          }
        ],
        "name": "VoteCast",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "voter",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "weight",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "string",
            "name": "reason",
            "type": "string"
          },
          {
            "indexed": false,
            "internalType": "bytes",
            "name": "params",
            "type": "bytes"
          }
        ],
        "name": "VoteCastWithParams",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "oldVotingDelay",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newVotingDelay",
            "type": "uint256"
          }
        ],
        "name": "VotingDelaySet",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "oldVotingPeriod",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newVotingPeriod",
            "type": "uint256"
          }
        ],
        "name": "VotingPeriodSet",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "BALLOT_TYPEHASH",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "CLOCK_MODE",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "COUNTING_MODE",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "pure",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "EXTENDED_BALLOT_TYPEHASH",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "descriptionHash",
            "type": "bytes32"
          }
        ],
        "name": "cancel",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          }
        ],
        "name": "castVote",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          },
          {
            "internalType": "address",
            "name": "voter",
            "type": "address"
          },
          {
            "internalType": "bytes",
            "name": "signature",
            "type": "bytes"
          }
        ],
        "name": "castVoteBySig",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          },
          {
            "internalType": "string",
            "name": "reason",
            "type": "string"
          }
        ],
        "name": "castVoteWithReason",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          },
          {
            "internalType": "string",
            "name": "reason",
            "type": "string"
          },
          {
            "internalType": "bytes",
            "name": "params",
            "type": "bytes"
          }
        ],
        "name": "castVoteWithReasonAndParams",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "uint8",
            "name": "support",
            "type": "uint8"
          },
          {
            "internalType": "address",
            "name": "voter",
            "type": "address"
          },
          {
            "internalType": "string",
            "name": "reason",
            "type": "string"
          },
          {
            "internalType": "bytes",
            "name": "params",
            "type": "bytes"
          },
          {
            "internalType": "bytes",
            "name": "signature",
            "type": "bytes"
          }
        ],
        "name": "castVoteWithReasonAndParamsBySig",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "clock",
        "outputs": [
          {
            "internalType": "uint48",
            "name": "",
            "type": "uint48"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "eip712Domain",
        "outputs": [
          {
            "internalType": "bytes1",
            "name": "fields",
            "type": "bytes1"
          },
          {
            "internalType": "string",
            "name": "name",
            "type": "string"
          },
          {
            "internalType": "string",
            "name": "version",
            "type": "string"
          },
          {
            "internalType": "uint256",
            "name": "chainId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "verifyingContract",
            "type": "address"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          },
          {
            "internalType": "uint256[]",
            "name": "extensions",
            "type": "uint256[]"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "descriptionHash",
            "type": "bytes32"
          }
        ],
        "name": "execute",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "payable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "descriptionHash",
            "type": "bytes32"
          }
        ],
        "name": "getProposalId",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timepoint",
            "type": "uint256"
          }
        ],
        "name": "getVotes",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "timepoint",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "params",
            "type": "bytes"
          }
        ],
        "name": "getVotesWithParams",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "hasVoted",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "descriptionHash",
            "type": "bytes32"
          }
        ],
        "name": "hashProposal",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "pure",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "name",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "nonces",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "uint256[]",
            "name": "",
            "type": "uint256[]"
          },
          {
            "internalType": "uint256[]",
            "name": "",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes",
            "name": "",
            "type": "bytes"
          }
        ],
        "name": "onERC1155BatchReceived",
        "outputs": [
          {
            "internalType": "bytes4",
            "name": "",
            "type": "bytes4"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "",
            "type": "bytes"
          }
        ],
        "name": "onERC1155Received",
        "outputs": [
          {
            "internalType": "bytes4",
            "name": "",
            "type": "bytes4"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "",
            "type": "bytes"
          }
        ],
        "name": "onERC721Received",
        "outputs": [
          {
            "internalType": "bytes4",
            "name": "",
            "type": "bytes4"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "proposalDeadline",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "proposalEta",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "proposalNeedsQueuing",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "proposalProposer",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "proposalSnapshot",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "proposalThreshold",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "proposalVotes",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "againstVotes",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "forVotes",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "abstainVotes",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "internalType": "string",
            "name": "description",
            "type": "string"
          }
        ],
        "name": "propose",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "calldatas",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "descriptionHash",
            "type": "bytes32"
          }
        ],
        "name": "queue",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "blockNumber",
            "type": "uint256"
          }
        ],
        "name": "quorum",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "quorumDenominator",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "timepoint",
            "type": "uint256"
          }
        ],
        "name": "quorumNumerator",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "quorumNumerator",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "target",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
          }
        ],
        "name": "relay",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "newProposalThreshold",
            "type": "uint256"
          }
        ],
        "name": "setProposalThreshold",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint48",
            "name": "newVotingDelay",
            "type": "uint48"
          }
        ],
        "name": "setVotingDelay",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint32",
            "name": "newVotingPeriod",
            "type": "uint32"
          }
        ],
        "name": "setVotingPeriod",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "proposalId",
            "type": "uint256"
          }
        ],
        "name": "state",
        "outputs": [
          {
            "internalType": "enum IGovernor.ProposalState",
            "name": "",
            "type": "uint8"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes4",
            "name": "interfaceId",
            "type": "bytes4"
          }
        ],
        "name": "supportsInterface",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "timelock",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "token",
        "outputs": [
          {
            "internalType": "contract IERC5805",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "newQuorumNumerator",
            "type": "uint256"
          }
        ],
        "name": "updateQuorumNumerator",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "contract TimelockController",
            "name": "newTimelock",
            "type": "address"
          }
        ],
        "name": "updateTimelock",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "version",
        "outputs": [
          {
            "internalType": "string",
            "name": "",
            "type": "string"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "votingDelay",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "votingPeriod",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "stateMutability": "payable",
        "type": "receive"
      }
    ],
    "bytecode": "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"
  },
  "DAOTreasury": {
    "abi": [
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "minDelay",
            "type": "uint256"
          },
          {
            "internalType": "address[]",
            "name": "proposers",
            "type": "address[]"
          },
          {
            "internalType": "address[]",
            "name": "executors",
            "type": "address[]"
          },
          {
            "internalType": "address",
            "name": "admin",
            "type": "address"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "inputs": [],
        "name": "AccessControlBadConfirmation",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "internalType": "bytes32",
            "name": "neededRole",
            "type": "bytes32"
          }
        ],
        "name": "AccessControlUnauthorizedAccount",
        "type": "error"
      },
      {
        "inputs": [],
        "name": "FailedCall",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "delay",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "minDelay",
            "type": "uint256"
          }
        ],
        "name": "TimelockInsufficientDelay",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "targets",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "payloads",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "values",
            "type": "uint256"
          }
        ],
        "name": "TimelockInvalidOperationLength",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "caller",
            "type": "address"
          }
        ],
        "name": "TimelockUnauthorizedCaller",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "predecessorId",
            "type": "bytes32"
          }
        ],
        "name": "TimelockUnexecutedPredecessor",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "operationId",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "expectedStates",
            "type": "bytes32"
          }
        ],
        "name": "TimelockUnexpectedOperationState",
        "type": "error"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "target",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
          }
        ],
        "name": "CallExecuted",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          },
          {
            "indexed": false,
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          }
        ],
        "name": "CallSalt",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "uint256",
            "name": "index",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "target",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
          },
          {
            "indexed": false,
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "delay",
            "type": "uint256"
          }
        ],
        "name": "CallScheduled",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "Cancelled",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "oldDuration",
            "type": "uint256"
          },
          {
            "indexed": false,
            "internalType": "uint256",
            "name": "newDuration",
            "type": "uint256"
          }
        ],
        "name": "MinDelayChange",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "previousAdminRole",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "newAdminRole",
            "type": "bytes32"
          }
        ],
        "name": "RoleAdminChanged",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
          }
        ],
        "name": "RoleGranted",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "account",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "sender",
            "type": "address"
          }
        ],
        "name": "RoleRevoked",
        "type": "event"
      },
      {
        "inputs": [],
        "name": "CANCELLER_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "DEFAULT_ADMIN_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "EXECUTOR_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "PROPOSER_ROLE",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "cancel",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address payable",
            "name": "to",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "amount",
            "type": "uint256"
          }
        ],
        "name": "emergencyWithdraw",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "target",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "payload",
            "type": "bytes"
          },
          {
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          }
        ],
        "name": "execute",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "payloads",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          }
        ],
        "name": "executeBatch",
        "outputs": [],
        "stateMutability": "payable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "getMinDelay",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "getOperationState",
        "outputs": [
          {
            "internalType": "enum TimelockController.OperationState",
            "name": "",
            "type": "uint8"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          }
        ],
        "name": "getRoleAdmin",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "getTimestamp",
        "outputs": [
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "grantRole",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "hasRole",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "target",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
          },
          {
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          }
        ],
        "name": "hashOperation",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "pure",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "payloads",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          }
        ],
        "name": "hashOperationBatch",
        "outputs": [
          {
            "internalType": "bytes32",
            "name": "",
            "type": "bytes32"
          }
        ],
        "stateMutability": "pure",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "isOperation",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "isOperationDone",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "isOperationPending",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "id",
            "type": "bytes32"
          }
        ],
        "name": "isOperationReady",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "uint256[]",
            "name": "",
            "type": "uint256[]"
          },
          {
            "internalType": "uint256[]",
            "name": "",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes",
            "name": "",
            "type": "bytes"
          }
        ],
        "name": "onERC1155BatchReceived",
        "outputs": [
          {
            "internalType": "bytes4",
            "name": "",
            "type": "bytes4"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "",
            "type": "bytes"
          }
        ],
        "name": "onERC1155Received",
        "outputs": [
          {
            "internalType": "bytes4",
            "name": "",
            "type": "bytes4"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "",
            "type": "bytes"
          }
        ],
        "name": "onERC721Received",
        "outputs": [
          {
            "internalType": "bytes4",
            "name": "",
            "type": "bytes4"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "callerConfirmation",
            "type": "address"
          }
        ],
        "name": "renounceRole",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes32",
            "name": "role",
            "type": "bytes32"
          },
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "revokeRole",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "target",
            "type": "address"
          },
          {
            "internalType": "uint256",
            "name": "value",
            "type": "uint256"
          },
          {
            "internalType": "bytes",
            "name": "data",
            "type": "bytes"
          },
          {
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          },
          {
            "internalType": "uint256",
            "name": "delay",
            "type": "uint256"
          }
        ],
        "name": "schedule",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address[]",
            "name": "targets",
            "type": "address[]"
          },
          {
            "internalType": "uint256[]",
            "name": "values",
            "type": "uint256[]"
          },
          {
            "internalType": "bytes[]",
            "name": "payloads",
            "type": "bytes[]"
          },
          {
            "internalType": "bytes32",
            "name": "predecessor",
            "type": "bytes32"
          },
          {
            "internalType": "bytes32",
            "name": "salt",
            "type": "bytes32"
          },
          {
            "internalType": "uint256",
            "name": "delay",
            "type": "uint256"
          }
        ],
        "name": "scheduleBatch",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "bytes4",
            "name": "interfaceId",
            "type": "bytes4"
          }
        ],
        "name": "supportsInterface",
        "outputs": [
          {
            "internalType": "bool",
            "name": "",
            "type": "bool"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "uint256",
            "name": "newDelay",
            "type": "uint256"
          }
        ],
        "name": "updateDelay",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "stateMutability": "payable",
        "type": "receive"
      }
    ],
    "bytecode": "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"
  },
  "DAOFactory": {
    "abi": [
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "initialOwner",
            "type": "address"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "constructor"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "owner",
            "type": "address"
          }
        ],
        "name": "OwnableInvalidOwner",
        "type": "error"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "account",
            "type": "address"
          }
        ],
        "name": "OwnableUnauthorizedAccount",
        "type": "error"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "creator",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "token",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "governor",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "treasury",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "string",
            "name": "name",
            "type": "string"
          }
        ],
        "name": "DAOCreated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": true,
            "internalType": "address",
            "name": "previousOwner",
            "type": "address"
          },
          {
            "indexed": true,
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "OwnershipTransferred",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "tokenTemplate",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "governorTemplate",
            "type": "address"
          },
          {
            "indexed": false,
            "internalType": "address",
            "name": "treasuryTemplate",
            "type": "address"
          }
        ],
        "name": "TemplatesUpdated",
        "type": "event"
      },
      {
        "anonymous": false,
        "inputs": [
          {
            "indexed": false,
            "internalType": "address",
            "name": "upgradeableGovernorTemplate",
            "type": "address"
          }
        ],
        "name": "UpgradeableGovernorTemplateUpdated",
        "type": "event"
      },
      {
        "inputs": [
          {
            "components": [
              {
                "internalType": "string",
                "name": "name",
                "type": "string"
              },
              {
                "internalType": "string",
                "name": "symbol",
                "type": "string"
              },
              {
                "internalType": "uint256",
                "name": "initialSupply",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "votingDelay",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "votingPeriod",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "proposalThreshold",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "quorumPercentage",
                "type": "uint256"
              },
              {
                "internalType": "uint256",
                "name": "timelockDelay",
                "type": "uint256"
              },
              {
                "internalType": "bool",
                "name": "deployerVeto",
                "type": "bool"
              },
              {
                "internalType": "bool",
                "name": "governorUpgradeable",
                "type": "bool"
              }
            ],
            "internalType": "struct DAOFactorySplit.DAOConfig",
            "name": "config",
            "type": "tuple"
          }
        ],
        "name": "createDAO",
        "outputs": [
          {
            "internalType": "address",
            "name": "token",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "governor",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "treasury",
            "type": "address"
          }
        ],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "governorTemplate",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "owner",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "renounceOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "_tokenTemplate",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "_governorTemplate",
            "type": "address"
          },
          {
            "internalType": "address",
            "name": "_treasuryTemplate",
            "type": "address"
          }
        ],
        "name": "setTemplates",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "template",
            "type": "address"
          }
        ],
        "name": "setUpgradeableGovernorTemplate",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "tokenTemplate",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [
          {
            "internalType": "address",
            "name": "newOwner",
            "type": "address"
          }
        ],
        "name": "transferOwnership",
        "outputs": [],
        "stateMutability": "nonpayable",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "treasuryTemplate",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      },
      {
        "inputs": [],
        "name": "upgradeableGovernorTemplate",
        "outputs": [
          {
            "internalType": "address",
            "name": "",
            "type": "address"
          }
        ],
        "stateMutability": "view",
        "type": "function"
      }
    ],
    "bytecode": "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"
  }
} as const;

export type DAOConfig = {
  name: string;
  symbol: string;
  initialSupply: bigint;
  votingDelay: bigint;
  votingPeriod: bigint;
  proposalThreshold: bigint;
  quorumPercentage: bigint;
  timelockDelay: bigint;
  deployerVeto: boolean;
  governorUpgradeable: boolean;
};

// Factory contract address will be set after deployment
export const DAO_FACTORY_ADDRESS = import.meta.env.VITE_DAO_FACTORY_ADDRESS as `0x${string}` | undefined;
